var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AvatarComponent',{attrs:{"size":_vm.size,"color":_vm.avatarColor.color,"text-color":_vm.avatarColor.text,"text":_vm.userInitials,"tooltip":_vm.showTooltip ? _vm.userName(_vm.userId) : ''}})}
var staticRenderFns = []

export { render, staticRenderFns }